import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "HeaderSearchBox" })
export default class HeaderSearchBox extends Vue {
    public localizer: any = Localizer;
    public search: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public closeSearch() {
        $(".wrap-tap").fadeOut();
        $(".app-search").removeAttr("data-show");
    }

    public showAll() {
        (<any>window).location = this.routes.Search_List + "?searchtext=" + this.search;
    }
};